<template>
  <div class="page">
    <LoginCom />
  </div>
</template>

<script>
import LoginCom from './login'
export default {
  name: 'login',
  components: {
    LoginCom
  }
}
</script>

<style scope>
.page {
  width: 100%;
  height: 100%;
}
</style>
